<template lang="pug">
.multiselect-table
    .labels
        span.labels__label {{ label }}
        span.labels__label {{ $t('mensagens.sistema.acao') }}
    .fields(v-for='(item, index) in list', :key='`${tableId}-item-${index}`')
        .select-field
            el-select.select-field__input(
                :loading='loading',
                :placeholder='$t("mensagens.comuns.selecione")',
                v-model='item.id',
                @clear='remove(index)',
                @change='change(index)',
                clearable,
                filterable
            )
                el-option(
                    v-for='({ nome, id, selecionado }, indexOption) in optionsList',
                    :key='`${tableId}-option-${id}-${indexOption}`',
                    :disabled='selecionado',
                    :label='nome',
                    :value='id'
                )
        i.el-icon-delete.button-delete(@click='remove(index)')
    .add-fields
        button.button-add(@click='add')
            i.mdi.mdi-plus.button-add__icon
            span.button-add__text {{ buttonAddLabel }}
        button.button-add(v-if='routeName', @click='goTo')
            i.mdi.mdi-plus.button-add__icon
            span.button-add__text {{ buttonRouteLabel }}
</template>

<script>
export default {
    name: 'MultiselectTable',
    props: {
        value: {
            type: Array || String || undefined || null,
            default: () => []
        },
        tableId: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        options: {
            type: Array || String || undefined || null,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        alertMessageAdd: {
            type: String,
            default: ''
        },
        buttonAddLabel: {
            type: String,
            default: ''
        },
        buttonRouteLabel: {
            type: String,
            default: ''
        },
        routeName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            list: [{ id: '' }]
        };
    },
    computed: {
        optionsList() {
            return this.options.map(({ nome, id }) => ({
                nome,
                id,
                selecionado: this.list.some(item => item.id === id)
            }));
        }
    },
    watch: {
        value: {
            handler: function (newValue, oldValue) {
                const newList = newValue && newValue.map(id => ({ id }));

                if (
                    !this.isEqual(newList, oldValue) &&
                    !this.isEqual(newList, this.list)
                ) {
                    this.list =
                        newValue.length > 0
                            ? newValue.map(id => ({ id }))
                            : [{ id: '' }];
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        isEqual(a, b) {
            return (a && JSON.stringify(a)) === (b && JSON.stringify(b));
        },
        goTo() {
            if (this.routeName) {
                this.$router.push({ name: this.routeName });
            }
        },
        change(index) {
            const item = this.list[index];

            if (item.id) {
                const list = this.list.map(({ id }) => id);
                this.$emit('input', list);
            }
        },
        add() {
            const hasEmptyField = this.list.some(item => item.id === '');

            if (hasEmptyField) {
                this.$notify.error(
                    this.alertMessageAdd ||
                        this.$t('mensagens.sistema.preenchaTodosOsCampos')
                );
            } else {
                this.list.push({ id: '' });
            }
        },
        remove(index) {
            let list = this.list;

            list.splice(index, 1);
            this.list = list;
            list = list.filter(({ id }) => id).map(({ id }) => id);
            this.$emit('input', list);
        }
    }
};
</script>

<style lang="scss">
.multiselect-table {
    display: flex;
    flex-direction: column;
    .labels {
        display: flex;
        justify-content: space-between;
        padding: 8px 16px;
        border-bottom: 2px solid $default-border-color;
        &__label {
            color: $primary;
            font-weight: bold;
        }
    }
    .fields {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 16px;
        border-bottom: 1px solid $default-border-color;
    }
    .select-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            border-radius: $default-border-radius;
            outline: 0;
            & input {
                color: var(--primary-font-color) !important;
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }
    .input-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            width: 100%;
            border-radius: $default-border-radius;
            border: 1px solid $default-border-color;
            outline: 0;
            padding: 0 15px;
        }
    }
    .add-fields {
        display: flex;
        gap: 8px;
        align-items: center;
        margin-top: 16px;
        .button-add {
            height: 40px;
            padding: 0 20px;
            border: 1px solid $primary;
            border-radius: $default-border-radius;
            background: none;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            cursor: pointer;
            &__icon {
                color: $primary;
                font-size: 18px;
            }
            &__text {
                font-weight: bold;
                color: $primary;
            }
        }
    }
    .button-delete {
        cursor: pointer;
        font-size: 20px;
        color: red;
        margin: 0 10px;
    }
}
.el-select-dropdown__item.is-disabled {
    cursor: unset !important;
}
</style>
